import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

/** Step 2's "Couldn't start the analysis" banner: Robbie's sentence and a dismiss. */
export const AnalysisErrorBanner: React.FC<{ message: string; onDismiss: () => void }> = ({ message, onDismiss }) => (
  <div className="flex items-start gap-s4 rounded-card border border-danger-border bg-danger-bg px-s6 py-[12px]">
    <AlertTriangle className="mt-[1px] h-4 w-4 shrink-0 text-danger-ink" />
    <div className="min-w-0 flex-1">
      <p className="text-row-title text-danger-ink">Couldn't start the analysis</p>
      <p className="mt-[2px] text-body-sm text-ink-body">{message}</p>
    </div>
    <button
      type="button"
      onClick={onDismiss}
      aria-label="Dismiss error"
      className="shrink-0 text-danger-ink/60 hover:text-danger-ink"
    >
      <X className="h-4 w-4" />
    </button>
  </div>
);

export default AnalysisErrorBanner;
